<!-- 经纪人管理组件 -->
<template>
  <el-dialog
    :title="title"
    :visible.sync="show"
    :width="width"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @close="handClose"
    class="captain"
    :destroy-on-close="true"
  >
    <el-form
      ref="ruleForm"
      label-position="top"
      size="small"
      :model="form"
      :rules="rules"
      class="enterprise-add-content"
    >
      <h1 class="flexCon soaning margin-b-5">
        <span class="font_500 font_16 _181818">经纪人信息</span>
      </h1>
      <nf-tips-only
        class="margin-b-5"
        title="温馨提示：请不要添加有收款限额的银行卡号（如：部分银行卡有每日收款额度限额1万，年收款限额20万），避免大额收款时，因限额导致收款失败"
      ></nf-tips-only>
      <div class="flexCon">
        <el-form-item
          prop="payeeBankCardNo"
          label="银行卡号"
          style="margin-bottom: 25px; margin-right: 50px"
        >
          <el-input
            v-model="form.payeeBankCardNo"
            placeholder="请输入银行卡号"
            @blur="handBlur(form.payeeBankCardNo)"
          />
        </el-form-item>
        <el-form-item label="开户行总行" prop="subBankName" style="margin-right: 50px">
          <nf-select
            ref="supBank"
            v-model="form.subBankName"
            methods-fn="get"
            placeholder="请输入开户行总行，支持模糊匹配"
            api-url="/rest/common/bank/getBankBySupBankName"
            :search-params="{ searchKey: 'bankName', subBankName: form.subBankName }"
            :response-transform-fn="bankNameFnBySup"
            :change="selectBankNameBySup"
          />
        </el-form-item>
      </div>
      <div class="flexCon">
        <el-form-item label="开户行支行" style="margin-right: 50px">
          <nf-select
            v-model="form.bankName"
            methods-fn="get"
            placeholder="请输入收款银行，支持模糊匹配"
            api-url="/rest/openAccount/findBankCodeLikeName"
            :search-params="{
              searchKey: 'bankName',
              subBankName: form.bankName,
            }"
            :response-transform-fn="bankNameFn"
            :change="selectBankName"
          />
        </el-form-item>
        <el-form-item prop="reserveMobileNo" label="银行预留手机">
          <el-input
            v-model="form.reserveMobileNo"
            maxlength="11"
            placeholder="请输入银行预留手机"
          />
        </el-form-item>
      </div>
      <div style="width: 100%; height: 1px; background: #eee; margin: 10px 0 10px 0" />
      <div class="flexCon">
        <el-form-item
          label="身份证照片正面"
          style="margin-right: 50px"
          prop="identityFrontFace"
          required
        >
          <div v-on:mouseenter="handleMouseenter('idcard_front', 'identityFrontFace')">
            <nf-upload-image
              :previewList="previewList"
              :value="form.identityFrontFace"
              code="identityFrontFace"
              filePath="driver"
              :removeExist="false"
              :onlyUploadImg="true"
              @handleRemove="handleRemove('identityFrontFace')"
              @handleUpload="handleUpload"
              @handleAvatarSuccess="
                file => flagOnchangecaptain(file, 'idcard_front', 'identityFrontFace')
              "
            />
          </div>
        </el-form-item>
        <el-form-item
          label="身份证照片反面"
          style="margin-right: 50px"
          prop="identityBackFace"
          required
        >
          <div
            class="image-view"
            v-on:mouseenter="handleMouseenter('idcard_back', 'identityBackFace')"
          >
            <nf-upload-image
              :previewList="previewList"
              :value="form.identityBackFace"
              code="identityBackFace"
              filePath="driver"
              :onlyUploadImg="true"
              :removeExist="false"
              @handleRemove="handleRemove('identityBackFace')"
              @handleUpload="handleUpload"
              @handleAvatarSuccess="
                file => flagOnchangecaptain(file, 'idcard_back', 'identityBackFace')
              "
            />
          </div>
        </el-form-item>
        <!-- <el-form-item
          label="身份证照片正面"
          style="margin-right: 50px"
          prop="identityFrontFace"
          required
        >
          <div
            class="image-view"
            v-on:mouseenter="handleMouseenter('idcard_front', 'identityFrontFace')"
          >
            <el-upload
              ref="uploads"
              class="avatar-uploader"
              action="#"
              drag
              :show-file-list="false"
              :auto-upload="false"
              :on-change="file => flagOnchangecaptain(file, 'idcard_front', 'identityFrontFace')"
              :before-upload="beforeAvatarUpload"
            >
              <div class="avatar" v-if="form.identityFrontFace">
                <img :src="form.identityFrontFace" class="avatar" />
                <div class="avatar-pop">
                  <div class="avatar-pop-flex">
                    <span @click.stop="handlePictureCardPreview(form.identityFrontFace)">
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span>
                      <i class="el-icon-plus"></i>
                    </span>
                    <span @click.stop="handleRemove('identityFrontFace')">
                      <i class="el-icon-delete"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div v-else class="upload_style">
                <div class="upload_button">点击上传</div>
                <div class="upload_button">Ctrl + V (粘贴)</div>
              </div>
            </el-upload>
          </div>
        </el-form-item> -->
        <!-- <el-form-item label="身份证照片反面" prop="identityBackFace" required>
          <div
            class="image-view"
            v-on:mouseenter="handleMouseenter('idcard_back', 'identityBackFace')"
          >
            <el-upload
              ref="uploads"
              class="avatar-uploader"
              action="#"
              drag
              :show-file-list="false"
              :auto-upload="false"
              :on-change="file => flagOnchangecaptain(file, 'idcard_back', 'identityBackFace')"
              :before-upload="beforeAvatarUpload"
            >
              <div class="avatar" v-if="form.identityBackFace">
                <img :src="form.identityBackFace" class="avatar" />
                <div class="avatar-pop">
                  <div class="avatar-pop-flex">
                    <span @click.stop="handlePictureCardPreview(form.identityBackFace)">
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span>
                      <i class="el-icon-plus"></i>
                    </span>
                    <span @click.stop="handleRemove('identityBackFace')">
                      <i class="el-icon-delete"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div v-else class="upload_style">
                <div class="upload_button">点击上传</div>
                <div class="upload_button">Ctrl + V (粘贴)</div>
              </div>
            </el-upload>
          </div>
        </el-form-item> -->
      </div>
      <el-form-item v-if="form.identityFrontFace" prop="payeeName" label="经纪人姓名">
        <el-input v-model="form.payeeName" placeholder="请输入经纪人姓名" />
      </el-form-item>
      <el-form-item v-if="form.identityFrontFace" prop="payeeIdentityNo" label="身份证号">
        <el-input v-model="form.payeeIdentityNo" placeholder="请输入经纪人身份证号" />
      </el-form-item>
      <el-form-item v-if="form.identityFrontFace" prop="identityAddress" label="身份证地址">
        <el-input v-model="form.identityAddress" placeholder="请输入经纪人身份证地址" />
      </el-form-item>
      <el-form-item v-if="form.identityBackFace" label="有效期">
        <div class="flexCon">
          <el-date-picker
            v-model="form.identityValidityStart"
            type="date"
            placeholder="选择日期"
            style="margin-right: 50px"
            @change="handleChange(form.identityValidityStart, 'identityValidityStart')"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
          />
          <el-date-picker
            v-model="form.identityValidityEnd"
            type="date"
            placeholder="选择日期"
            @change="handleChange(form.identityValidityEnd, 'identityValidityEnd')"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
          />
        </div>
      </el-form-item>
      <div class="flexCon">
        <el-form-item label="所属项目" prop="projectIdList" style="margin-right: 50px">
          <el-select
            v-model="form.projectIdList"
            multiple
            filterable
            placeholder="请选择所属项目"
            no-data-text="请在项目列表中创建项目"
          >
            <el-option
              v-for="project of projectList"
              :key="project.id"
              :label="project.name"
              :value="project.id"
            />
          </el-select>
        </el-form-item>
      </div>
    </el-form>
    <div slot="footer">
      <el-button @click="handClose"> 取消 </el-button>
      <el-button type="primary" @click="handSubmit"> 提交信息 </el-button>
    </div>
    <NfLoading v-if="showLoad" />
  </el-dialog>
</template>

<script>
import { captainUpdate, getBankByCard } from '@/api/captain';
import * as imageConversion from 'image-conversion';
import NfLoading from '@/components/nf-loading/index';
import { validaIteCode, validaIteName, validateIdCrad, validaItePhoneNo } from './rule';
import { getProjectListByBid } from '@/api/project';
import nfUploadImage from '@/components/nf-upload-image';

export default {
  components: {
    NfLoading,
    nfUploadImage,
  },
  props: {
    // 是否显示 Dialog
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '编辑经纪人信息',
    },
    // Dialog 的宽度
    width: {
      type: String,
      default: '980px',
    },
    // 司机信息
    info: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    //这里存放数据
    return {
      form: {
        bankCardNo: '',
        payeeName: '',
        subBankName: '',
        payeeIdentityNo: '',
        identityFrontFace: '',
        identityBackFace: '',
        payeeBankCardNo: '',
        bankName: '',
        bankShortName: '',
        reserveMobileNo: '',
        bankProvince: '',
        bankCity: '',
        payeeType: '',
        isDefault: '',
        isDelete: '',
        date: [],
        projectIdList: [],
        identityValidityStart: '',
        identityValidityEnd: '',
      },
      rules: {
        payeeBankCardNo: [
          { required: true, validator: validaIteCode, trigger: ['blur', 'change'] },
        ],
        payeeName: [{ required: true, validator: validaIteName, trigger: ['blur', 'change'] }],
        subBankName: [{ required: true, message: '请输入开户行总行', trigger: ['blur'] }],
        payeeIdentityNo: [
          { required: true, validator: validateIdCrad, trigger: ['blur', 'change'] },
        ],
        identityBackFace: [
          { required: true, message: '请上传身份证照片反面', trigger: ['blur', 'change'] },
        ],
        identityFrontFace: [
          { required: true, message: '请上传身份证照片正面', trigger: ['blur', 'change'] },
        ],
        reserveMobileNo: [
          { required: true, validator: validaItePhoneNo, trigger: ['blur', 'change'] },
        ],
      },
      key: '',
      value: '',
      showLoad: false,
      bankByCard: '',
      projectList: [], // 项目列表
    };
  },
  watch: {
    showLoad(val) {
      if (val) {
        setTimeout(() => {
          this.showLoad = false;
        }, 10000);
      }
    },
  },
  computed: {
    bankTips() {
      return this.$store.state.bankTips;
    },
    // 项目数据权限
    isProjectPermission() {
      return this.$store.state.user.userInfo.dataPermission === 'PROJECT';
    },
    previewList() {
      const list = [];
      for (const item in this.form) {
        if (item === 'identityBackFace' || item === 'identityFrontFace') {
          list.push(this.form[item]);
        }
      }
      return list;
    },
  },
  created() {
    this.form = Object.assign({}, this.form, this.info);
    this.getProjectPageList();
    if (this.isProjectPermission) {
      this.rules = {
        ...this.rules,
        projectIdList: [{ required: true, message: '请选择所属项目', trigger: ['blur', 'change'] }],
      };
    }
  },
  mounted() {
    window.addEventListener('paste', this.handlePasteCaptain, true);
  },
  //方法集合
  methods: {
    handleUpload(value) {
      if (value.identityPositiveImage) {
        this.form.identityFrontFace = value.identityPositiveImage;
      }
      if (value.identityReverseImage) {
        this.form.identityBackFace = value.identityReverseImage;
      }
    },
    bankNameFn(list, setOptionsFn) {
      setOptionsFn(
        list.map(bankName => {
          return {
            value: bankName.bankName,
            label: bankName.bankName,
          };
        }),
      );
    },
    bankNameFnBySup(list, setOptionsFn) {
      setOptionsFn(
        list.map(bankName => {
          return {
            value: bankName,
            label: bankName,
          };
        }),
      );
    },
    // 开户行总行
    selectBankNameBySup(item) {
      if (item && item.label) {
        this.form.supBankName = item.label && item.label;
      }
    },
    // 开户行支行
    selectBankName(item) {
      if (item && item.label) {
        this.form.bankName = item.label && item.label;
      }
    },
    // 获取集团下项目列表
    async getProjectPageList() {
      const { data, code } = await getProjectListByBid({ page: 1, size: 999 });
      if (code === 200) {
        // 过滤掉默认项目
        this.projectList = data.list.filter(item => item.isDefaultProject !== 1);
      }
    },
    async handBlur(val) {
      let str = '';
      if (!this.form.subBankName) {
        if (val && val.length && (val.length > 5 || val.length == 5)) {
          if (val.length > 14 || val.length == 14) {
            str = Number(val.replace(/\\/g, '/'));
          } else {
            str = Number(val.replace(/\\/g, '/').slice(0, 6));
          }
          const res = await getBankByCard({
            bankCard: str,
          });
          this.form.subBankName = res.data.bankName;
          this.$refs['supBank'].value = res.data.bankName;
          this.$refs['supBank'].remoteMethod(res.data.bankName);
        }
      }
    },
    // 关闭按钮
    handClose() {
      this.logEvent('info', 'button', `编辑经纪人-关闭`);
      this.$emit('handleClose');
    },
    // 保存按钮
    handSubmit() {
      this.logEvent('info', 'button', `编辑经纪人-保存`);
      this.$refs['ruleForm'].validate(async valid => {
        if (valid) {
          if (this.form.identityFrontFace && this.form.identityBackFace) {
            await captainUpdate(this.form).then(res => {
              if (res.code == 200) {
                this.$$message(res.message, 'success');
                this.$emit('handleSubmit');
              }
            });
          } else {
            this.$$message('请上传证件完善信息后再提交信息', 'error');
          }
        } else {
          return false;
        }
      });
    },
    // 复制粘贴
    handlePasteCaptain(event) {
      const { items } = event.clipboardData || window.clipboardData;
      let file = null;
      if (!items || items.length === 0) {
        this.$message.error('当前浏览器不支持本地');
        return;
      }
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          file = items[i].getAsFile();
        }
      }
      if (file) {
        if (this.form.payeeBankCardNo) {
          this.imageUploadcaptain(file, this.value, this.key);
        } else {
          this.$$message('请优先填写银行卡号', 'error');
        }
      }
    },
    handleMouseenter(value, key) {
      const inputs = document.querySelectorAll('input');
      inputs.forEach(element => {
        element.blur();
      });
      this.value = value;
      this.key = key;
    },
    handleMouseleave() {
      this.value = '';
      this.key = '';
    },
    // 证件上传 ocr 识别
    flagOnchangecaptain(file, value, key) {
      if (this.form.payeeBankCardNo) {
        this.imageUploadcaptain(file, value, key);
      } else {
        this.$$message('请优先填写银行卡号', 'error');
      }
    },
    // 压缩的方法
    yasuo(file) {
      return new Promise((resolve, reject) => {
        imageConversion.compressAccurately(file, 500).then(res => {
          const compressed_file = new File([res], file.name, {
            type: file.type,
            lastModified: Date.now(),
          });
          compressed_file.uid = file.uid;
          return resolve(compressed_file);
        });
      });
    },
    // 封装方法  ---  转时间
    getTimeDate(val, obj) {
      const str = JSON.parse(val);
      return `${str[obj].toString().slice(0, 4)}-${str[obj].toString().slice(4, 6)}-${str[obj]
        .toString()
        .slice(6, 8)} 00:00:00`;
    },
    // 上传
    handleAvatarSuccess(res) {},
    // 上传之前
    beforeAvatarUpload(file) {
      const isPng = file.type === 'image/png';
      const isJPG = file.type === 'image/jpeg' || 'image/jpg';
      const isLt2M = file.size / 1024 / 1024 < 30;
      if (!isPng && !isJPG) {
        this.$message.error('上传头像图片只能是 JPG或PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 30MB!');
      }
      return (isJPG || isPng) && isLt2M;
    },
    handleChange(val, str) {
      if (str == 'identityValidityEnd') {
        this.form.identityValidityEnd = `${val} 00:00:00`.toString();
      } else if (str == 'identityValidityStart') {
        this.form.identityValidityStart = `${val} 00:00:00`.toString();
      }
    },
    // 封装上传
    imageUploadcaptain(file, value, key) {
      this.showLoad = true;
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          groupId: window.localStorage.userInfo
            ? JSON.parse(window.localStorage.userInfo).groupId
            : '',
        },
      };
      const formData = new FormData();
      this.yasuo(file).then(i => {
        formData.append('file', i);
        formData.append('imageType', value);
        formData.append('filePath', 'collect');
        formData.append('bankCardNo', this.form.payeeBankCardNo);
        // 上传图片
        this.$http.post('/rest/upload/v2/importfile', formData, config).then(res => {
          if (res.code == 200 && value == 'idcard_front') {
            setTimeout(() => {
              this.showLoad = false;
            }, 500);
            this.form.identityFrontFace = res.data.ossUrl;
            this.form.payeeName = res.data.ocrStr && JSON.parse(res.data.ocrStr).name;
            this.form.payeeIdentityNo = res.data.ocrStr && JSON.parse(res.data.ocrStr).num;
            this.form.identityAddress = res.data.ocrStr && JSON.parse(res.data.ocrStr).address;
          } else if (res.code == 200 && value == 'idcard_back') {
            setTimeout(() => {
              this.showLoad = false;
            }, 500);
            this.form.identityBackFace = res.data.ossUrl;
            this.form.date = [
              res.data.ocrStr && this.getTimeDate(res.data.ocrStr, 'start_date'),
              res.data.ocrStr && this.getTimeDate(res.data.ocrStr, 'end_date'),
            ];
            this.form.identityValidityStart =
              res.data.ocrStr && this.getTimeDate(res.data.ocrStr, 'start_date');
            this.form.identityValidityEnd =
              res.data.ocrStr && this.getTimeDate(res.data.ocrStr, 'end_date');
          } else {
            setTimeout(() => {
              this.showLoad = false;
            }, 500);
          }
        });
      });
    },
    // handlePictureCardPreview(val) {
    //   const imgs = window.location.origin + val;
    //   if (val) {
    //     window.open(imgs, '_blank', 'toolbar=yes, width=900, height=600');
    //   } else {
    //     const img = new Image();
    //     img.src = val;
    //     const newWin = window.open('', '_blank', 'toolbar=yes, width=900, height=600');
    //     newWin.document.write(img.outerHTML);
    //     newWin.document.close();
    //   }
    // },
    handleRemove(parma) {
      this.$confirm('此操作将删除该图片, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.form[parma] = '';
        })
        .catch(() => {});
    },
  },
  destroyed() {
    window.removeEventListener('paste', this.handlePasteCaptain, true);
  },
};
</script>
<style lang="scss" scoped>
.soaning {
  width: 100%;
  height: 55px;
  background: #f4f7fa;

  span {
    line-height: 55px;
    display: inline-block;
    margin-left: 20px;
  }
}

.enterprise-add-content {
  padding: 0px 20px 20px !important;
  position: relative;
}

.el-form-item__content > div {
  display: flex;
}

.el-form-item__content > div > span {
  display: inline-block;
  background: #445ebf;
  border-radius: 4px;
  color: #ffff;
  line-height: 32px;
  text-align: center;
  width: 100px;
  padding: 0 8px;
  height: 32px;
  margin-left: 20px;
}

.el-form-item__content > div > h3 {
  width: 104px;
  height: 30px;
  color: #445ebf;
  line-height: 30px;
  margin-left: 10px;
}

.upload_style {
  color: #bfccda;
  width: 120px;
  border-radius: 6px;
  height: 120px;
  border: 1px dashed #bfccda;
  text-align: center;

  .upload_button {
    display: block;
    border: 1px solid #bfccda;
    width: 80px;
    height: 25px;
    line-height: 25px;
    font-size: 12px;
    color: #bfccda;
    margin: 20px auto;
    border-radius: 15px;
  }

  .upload_button:nth-child(2) {
    width: 100px;
  }
}

.upload_style:hover {
  border: 1px dashed #445ebf;

  .upload_button {
    border: 1px solid #445ebf;
    color: #445ebf;
  }
}

::v-deep .el-upload-dragger {
  width: 130px !important;
  height: 100px !important;
  border: 0;
}
::v-deep .ca-cover-img {
  width: 132px !important;
  //   height: 66px !important;
  max-height: 66px !important;
  height: auto !important;
  margin-top: 25px;
}
::v-deep .nf-upload-image {
  width: 135px !important;
  height: 104px !important;
  border: 1px dashed #ccc !important;
  border-radius: 4px !important;
  padding: 0 !important;
}
::v-deep .nf-upload-image .ca-value {
  width: 132px !important;
  height: 102px !important;
  //   border: 1px dashed #ccc;
}
::v-deep .ca-value-img {
  width: 132px !important;
  height: 102px !important;
}
::v-deep .ca-pop {
  width: 132px !important;
  height: 102px !important;
  padding-top: 20px !important;
}
::v-deep .nf-upload-image .ca-value .ca-pop i {
  margin: 0 14px !important;
}
</style>
<style lang="scss">
.captain {
  .el-input__inner,
  .el-date-editor {
    width: 350px !important;
  }

  .avatar-uploader .el-upload {
    box-sizing: border-box;
    border-radius: 6px;
    cursor: pointer;
  }

  .el-dialog {
    height: 80%;
    // min-width: 830px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .el-dialog__body {
    flex: 1;
    padding: 10px 20px 20px 20px !important;
    overflow: auto;
  }

  .el-dialog__header {
    height: 60px;
  }

  .el-dialog__footer {
    width: 100%;
    border-top: 1px solid #eee !important;
    height: 60px !important;
  }

  .image-view,
  .avatar,
  .avatar-uploader {
    width: 122px !important;
    height: 122px !important;
    border-radius: 6px !important;
    display: inline-block;
  }

  .avatar {
    position: relative;

    .avatar-pop {
      display: none;
      width: 122px !important;
      height: 122px !important;
      line-height: 122px !important;
      position: absolute;
      top: 0;
      left: 0;

      .avatar-pop-flex {
        background-color: rgba(0, 0, 0, 0.4);
        color: #ffffff;
        display: flex;
        justify-content: space-around;
      }
    }
  }

  .avatar:hover {
    .avatar-pop {
      display: block;
    }
  }

  .el-upload {
    width: 132px !important;
    height: 102px !important;
    display: inline-block;
    border-radius: 4px;
    background: #fff;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 24px;
    color: #bfccda;
    width: 122px;
    border-radius: 6px;
    height: 122px;
    line-height: 122px;
    border: 1px dashed #bfccda;
    text-align: center;
  }

  .el-form-item__error {
    margin-top: 3px !important;
  }
  .ca-form-item-photos {
    width: 100% !important;
  }
  //   .nf-upload-image {
  //     width: 132px !important;
  //     height: 102px !important;
  //   }
  //   .nf-upload-image .ca-value .ca-value-img {
  //     width: 142px !important;
  //     height: 102px !important;
  //   }
  //   .nf-upload-image .ca-value .ca-pop {
  //     width: 140px !important;
  //     height: 102px !important;
  //   }
  //   .nf-upload-image .ca-value .ca-pop i {
  //     margin-top: 40px !important;
  //   }
  //   .nf-upload-image {
  //     width: 182px !important;
  //     height: 125px !important;
  //   }
  //   ::v-deep .nf-upload-image .ca-value {
  //     width: 175px !important;
  //     height: 100px !important;
  //     border: 1px dashed #ccc;
  //   }
  //   ::v-deep .ca-value-img {
  //     width: 175px !important;
  //     height: 100px !important;
  //   }
  //   ::v-deep .ca-pop {
  //     width: 175px !important;
  //     height: 100px !important;
  //     padding-top: 20px !important;
  //   }
  //   ::v-deep .nf-upload-image .ca-value .ca-pop i {
  //     margin: 0 24px !important;
  //   }
}
</style>
